"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalFooter_1 = require("./GlobalFooter");
exports.default = GlobalFooter_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalFooter/index.js
// module id = 1377
// module chunks = 8